module.exports = __webpack_public_path__ + "static/media/Chinese.cfdd4347.svg";